<template>
    <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="120px"> </el-form>
</template>

<script>
export default {
    name: 'output_0',
    data() {
        return {
            formInfo: {},
            rules: {}
        };
    },
    methods: {
        getFromInfo() {
            return JSON.stringify(this.formInfo);
        }
    }
};
</script>

<style scoped></style>
